import React, { memo, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { Form, Modal, Select } from 'antd';
import { FormComponentProps } from 'antd/lib/form';
import { storeSelectors } from '@ui/scenes/Store';
import { StoreState } from '@ui/store/rootReducer';
import { metaSelectors } from '@ui/store/meta';
import { updateReference } from '@ui/api/v2/store.api';
import { useRouter } from '../../hooks/useRouter';

import './EditReference.less';
import { Button } from '@ui/components';

interface ICollection {
  id: number;
  name: string;
}

interface IStore {
  collections: {
    collection: ICollection;
  }[];
}

interface IProps extends FormComponentProps {
  isVisible: boolean;
  hideIsEditReferenceModal: () => void;
  store: IStore;
  collections: ICollection[];
}

function EditReference({
  form: { getFieldDecorator, getFieldValue },
  isVisible,
  hideIsEditReferenceModal,
  store,
  collections,
}: IProps) {
  const { match } = useRouter<{ storeId: string }>();

  const storeCollections = useMemo(() => {
    if (store) {
      return [...store.collections]
        .sort((a, b) => (a.collection.name < b.collection.name ? -1 : 1))
        .map((c) => c.collection.id.toString());
    }
    return [];
  }, [store]);

  const collectionsSorted = useMemo(() => {
    if (collections) {
      return [...collections].sort((a: any, b: any) => (a.name < b.name ? -1 : 1));
    }
    return [];
  }, [collections]);

  const sendCollections = useCallback(async () => {
    const value = getFieldValue('collections');
    const collectionsToAdd = value.filter((id: string) => !storeCollections.includes(id));
    const collectionsToDelete = storeCollections.filter((id: string) => !value.includes(id));
    console.log(collectionsToAdd, collectionsToDelete);
    hideIsEditReferenceModal();
    await updateReference(match.params.storeId, collectionsToAdd, collectionsToDelete);
    window.location.reload();
  }, [getFieldValue, match.params, hideIsEditReferenceModal, storeCollections]);

  const handleSelectAll = (value: string[]) => {
    if (value.includes('all')) {
      return collectionsSorted.map((c) => c.id.toString());
    }
    return value;
  };

  return (
    <Modal
      width="90%"
      style={{ top: '50px' }}
      footer={null}
      onCancel={hideIsEditReferenceModal}
      visible={isVisible}
      title="Редактировать эталон"
    >
      <div className="edit-reference__send-button-wrapper">
        <Button type="primary" onClick={sendCollections}>
          Сохранить
        </Button>
      </div>
      <Form.Item label="Эталон">
        {getFieldDecorator('collections', {
          initialValue: storeCollections,
          getValueFromEvent: handleSelectAll,
        })(
          <Select className="edit-reference__select" mode="multiple" size="large" onChange={handleSelectAll}>
            <Select.Option key="all" value="all">
              Выбрать все
            </Select.Option>
            {collectionsSorted.map((d) => (
              <Select.Option key={d.id}>{d.name}</Select.Option>
            ))}
          </Select>,
        )}
      </Form.Item>
    </Modal>
  );
}

const mapStateToProps = (state: StoreState) => ({
  store: storeSelectors.getStore(state),
  collections: metaSelectors.getCollections(state),
});

export default connect(mapStateToProps)(Form.create({ name: 'edit-reference' })(memo(EditReference)));



// WEBPACK FOOTER //
// ./src/components/EditReference/EditReference.tsx